export const LOG_OUT = 'Log Out'
